
<div style="margin-left: 75px;" v-resize = "onResize">
    <c-app-bar
        :title         = "'IMPORT - ' + title"
        :categories    = "[]"
        :enable-search = "false"
    >
        <template v-slot:search>
            <v-spacer />
        </template>
    </c-app-bar>

    <div
        class  = "lm-border"
        style  = "margin-right: 75px;"
        :style = "'height:' + (size.y- 10) + 'px'"
        @dragover.prevent
        @drop.prevent
    >
        <div class="ml-4 mt-3" style="width: 300px" v-if="!importData">
            <c-customer-select
                v-model="customer"
                label="Kunde"
                :hide-details = "true"
            />
        </div>
        <div
            v-if       = "!importData && customer"
            @drop      = "onDrop"
            @dragleave = "fileDragOut"
            @dragover  = "fileDragIn"
            class      = "v-flex w-100 dropzone"
            :class     = "drag ? 'drop-allowed' : ''"
            @dragover.prevent
            @drop.prevent
        >
            <div class="drop-zone-icon">
                <div style="text-align: center;">
                    <v-icon class="primary--text" size="70">mdi-cloud-upload</v-icon>
                </div>
                <div class="primary--text drop-zone-label">
                    {{ $t("importer.drophere") }}
                </div>
            </div>
        </div>

        <div class="w-100 h-100" v-if="importData">
            <div class="pa-3 h-100" :key="refresh">
                <div class="mt-0 pa-3 pt-0 v-flex">
                    <div>
                        <v-text-field
                            v-model     = "search"
                            append-icon = "mdi-magnify"
                            :label      = "$t('importer.search')"
                            style       = "font-size: 15px;"
                            @input      = "onSearch"
                            single-line
                            clearable
                            hide-details
                            dense
                        />
                    </div>
                    <v-btn
                        class="dialog-button ml-3"
                        color="primary"
                        :disabled = "!importData || (importData && importData.errors > 0)"
                        @click="onImport"
                    >
                        {{ $t("importer.doimport") }}
                    </v-btn>

                    <v-btn
                        class="dialog-button ml-3"
                        color="primary"
                        @click="onReset"
                    >
                        {{ $t("importer.newimport") }}
                    </v-btn>
                    <div v-if="customer" class="primary--text" style="text-align: center; flex-grow: 1 !important; font-size: 20px; font-weight: 600; padding-top: 0">
                        {{ customer.name }}
                    </div>

                    <v-btn
                        class="dialog-button ml-3"
                        color="primary"
                        @click="onErrors"
                        style="width: 185px;"
                    >
                        {{ filter.errors ? $t("importer.filter.errors.on") : $t("importer.filter.errors.off") }}
                    </v-btn>
                </div>
                <v-divider class="mb-3" />
                    <c-side-button
                        v-if    = "!importData.oneRowPerUnit"
                        v-model ="inout"
                        :left   = "true"
                        :title  = "inout ? $t('importer.output.title') : $t('importer.input.title')"
                        class   = "inout-button"
                    />
                    <p-import-input
                        v-if     = "inout"
                        :size    = "size"
                        :columns = "importData.inputColumns"
                        :rows    = "importData.inputRows"
                        :filter  = "filter"
                    />
                    <p-import-output
                        v-if    = "!inout && !importData.oneRowPerUnit"
                        :data   = "importData.output"
                        :size   = "size"
                        :filter = "filter"
                    />
            </div>
        </div>
    </div>
</div>
